<!-- CF - 10/01/2025 - To be deleted when the Messages.vue and DMS.vue pages are deleted -->
<template>
  <VTextField
    :model-value="value"
    :rules="rules"
    v-bind="$attrs"
    variant="underlined"
    :disabled="disabled"
    data-testid="base-input-text"
    @update:model-value="handleInput"
    @click="emit('click', $event)"
    @blur="emit('blur', $event)"
  />
</template>

<script setup>
  defineProps({
    value: {
      type: [String, Number],
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["input", "click", "blur"]);

  const handleInput = (e) => {
    emit("input", e);
  };
</script>
